export const text = {
  text: {
    account: {
      supporttickets: {
        createticket: {
          ticketcategory: {
            quality: 'Qualidade',
            others: 'Outros',
            deliverystatus: 'Entrega'
          }
        }
      }
    }
  }
};
